/**
 * Carousels and marquee sliders for brands, collections, and reviews.
 */
(function () {
  function getPerView(root) {
    const raw = root.dataset.carouselPerView || '4|2|1';
    const parts = raw.split('|').map((n) => parseInt(n, 10) || 1);
    const width = window.innerWidth;
    if (width >= 1024) return parts[0] || 4;
    if (width >= 768) return parts[1] || parts[0] || 2;
    return parts[2] || parts[1] || 1;
  }

  function initCarousel(root) {
    if (root.dataset.carouselInit === 'true') return;
    const viewport = root.querySelector('[data-carousel-viewport]');
    const track = root.querySelector('[data-carousel-track]');
    if (!viewport || !track) return;

    root.dataset.carouselInit = 'true';
    const slides = [...track.children];
    if (slides.length < 1) return;

    const prevBtn = root.querySelector('[data-carousel-prev]');
    const nextBtn = root.querySelector('[data-carousel-next]');
    const dotsRoot = root.querySelector('[data-carousel-dots]');
    const autoplay = root.dataset.carouselAutoplay === 'true'
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = (parseInt(root.dataset.carouselSpeed, 10) || 5) * 1000;
    let index = 0;
    let timer = null;
    let perView = getPerView(root);
    let maxIndex = 0;
    let touchStartX = 0;

    const buildDots = () => {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';
      const count = maxIndex + 1;
      if (count <= 1) return;
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === index) dot.classList.add('is-active');
        dot.addEventListener('click', () => goTo(i));
        dotsRoot.appendChild(dot);
      }
    };

    const updateDots = () => {
      if (!dotsRoot) return;
      dotsRoot.querySelectorAll('.carousel__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    };

    const applyLayout = () => {
      perView = getPerView(root);
      maxIndex = Math.max(0, slides.length - perView);
      if (index > maxIndex) index = 0;
      const slideWidth = 100 / perView;
      slides.forEach((slide) => {
        slide.style.flexBasis = `${slideWidth}%`;
        slide.style.maxWidth = `${slideWidth}%`;
      });
      track.style.transform = `translateX(-${(100 / perView) * index}%)`;
      buildDots();
      updateDots();
    };

    const goTo = (nextIndex) => {
      if (slides.length <= perView) {
        index = 0;
        track.style.transform = 'translateX(0)';
        updateDots();
        return;
      }
      if (nextIndex < 0) index = maxIndex;
      else if (nextIndex > maxIndex) index = 0;
      else index = nextIndex;
      track.style.transform = `translateX(-${(100 / perView) * index}%)`;
      updateDots();
    };

    const step = (delta) => goTo(index + delta);

    const startAutoplay = () => {
      if (!autoplay || slides.length <= perView) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => step(1), speed);
    };

    const stopAutoplay = () => window.clearInterval(timer);

    if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => step(1));

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    viewport.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    viewport.addEventListener('touchend', (e) => {
      const delta = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(delta) < 40) return;
      step(delta > 0 ? -1 : 1);
    }, { passive: true });

    window.addEventListener('resize', applyLayout);
    applyLayout();
    startAutoplay();
  }

  function initMarquee(root) {
    if (root.dataset.marqueeInit === 'true') return;
    const track = root.querySelector('[data-marquee-track]');
    if (!track || track.children.length < 1) return;

    root.dataset.marqueeInit = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const items = [...track.children];
    items.forEach((item) => track.appendChild(item.cloneNode(true)));

    const speed = parseInt(root.dataset.marqueeSpeed, 10) || 25;
    track.style.setProperty('--marquee-duration', `${speed}s`);
    track.classList.add('marquee__track--active');

    if (root.dataset.marqueePause === 'true') {
      root.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
      root.addEventListener('mouseleave', () => { track.style.animationPlayState = 'running'; });
    }
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  document.querySelectorAll('[data-marquee]').forEach(initMarquee);
})();
